import { Navigate } from "react-router-dom";
import { InboxConversationHeader } from "./InboxConversationHeader";
import { InboxConversationMessageList } from "./InboxConversationMessageList";
import { InboxThreadSMSCompositionFooter } from "./InboxThreadSMSCompositionFooter";
import { useParsedInboxRoute } from "../../hooks";
import { InboxThreadChatCompositionFooter } from "./InboxThreadChatCompositionFooter";
import { useInboxConversation } from "@tellescope/tanstack-query";
import { InboxThreadEmailCompositionFooter } from "./InboxThreadEmailCompositionFooter";
import { InboxConversationEmailList } from "./InboxConversationEmailList";
import { InboxThreadZendeskCompositionFooter } from "./InboxThreadZendeskCompositionFooter";
import { InboxConversationZendeskList } from "./InboxConversationZendeskList";

/**
 * Component for displaying the conversation view of a selected thread
 * Isolated for better performance - only re-renders when selected thread or messages change
 */
export const InboxConversationView = () => {
  const { threadId, channel } = useParsedInboxRoute() ?? {};
  const conversationData = useInboxConversation(threadId ?? "", { enabled: !!threadId });

  if (!threadId) {
    return <Navigate to="../.." replace />;
  }

  switch (channel?.route) {
    case "sms":
    case "groupmms":
      return (
        <>
          <InboxConversationHeader threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxConversationMessageList threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxThreadSMSCompositionFooter threadId={threadId ?? ""} conversationData={conversationData} />
        </>
      );
    case "chat":
      return (
        <>
          <InboxConversationHeader threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxConversationMessageList threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxThreadChatCompositionFooter threadId={threadId ?? ""} conversationData={conversationData} />
        </>
      );
    case "email":
      return (
        <>
          <InboxConversationHeader threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxConversationEmailList threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxThreadEmailCompositionFooter threadId={threadId ?? ""} conversationData={conversationData} />
        </>
      );
    case "zendesk":
      return (
        <>
          <InboxConversationHeader threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxConversationZendeskList threadId={threadId ?? ""} conversationData={conversationData} />
          <InboxThreadZendeskCompositionFooter threadId={threadId ?? ""} conversationData={conversationData} />
        </>
      );
    default:
      return <Navigate to="../.." replace />;
  }
};
